<h2 mat-dialog-title>Confirmar Pago</h2>
<mat-dialog-content>
  <p>¿Seguro que quieres realizar el pago?</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button class="btn btn-primary" (click)="onConfirm()">Confirmar</button>
  <button mat-button (click)="onCancel()">Cancelar</button>
</mat-dialog-actions>
